import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const currentRoute = window.location.pathname.replace(/\/+$/, '') || '/';
const prerenderedRoute = rootElement.dataset.prerenderedRoute;

if (prerenderedRoute === currentRoute) {
  hydrateRoot(rootElement, app);
} else {
  document.head.querySelectorAll('[data-home-static="true"]').forEach((element) => {
    element.remove();
  });
  rootElement.replaceChildren();
  createRoot(rootElement).render(app);
}
